import { List } from 'immutable'
import React from 'react'
import { nothing, Widget } from 'widgets-for-react'
import { any, fromJSX, Updater } from 'widgets-for-react'
import { partition } from '../../../../utils/utils'
import { blocksWidget } from '../../blocks/blocksWidget'
import { cmsPageStateUpdaters, Page, SpecialistPage } from '../../cmsPageState'
import { SpecialistPageCVLayout, SpecialistPageHeader, SpecialistPageButtonLayout } from './specialistPageLayout'

export const specialistPageWidget =
  (acceptVideoCookie: () => void) =>
    (page: SpecialistPage): Widget<Updater<Page>> => {
      const specialist = page.specialist
      const blocks = page.blocks

      const quoteIndex = blocks.findIndex(b => b.kind == 'quoteBlock')
      const [quoteblock, rest] = partition(blocks, (_, index) => index == quoteIndex)

      const relatedIndex = rest.findIndex(b => b.kind == 'relatedContentBlock')
      const [relatedBlock, buildingBlocks] = partition(rest, (_, index) => index == relatedIndex)

      if (!specialist) return any([
        blocksWidget(acceptVideoCookie)(quoteblock).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
        blocksWidget(acceptVideoCookie)(buildingBlocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
        blocksWidget(acceptVideoCookie)(relatedBlock).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
      ])

      const departments = specialist.subDepartments.concat(specialist.departments)

      return any([
        fromJSX(() => (
          <SpecialistPageHeader
            title={specialist.title}
            intro={page.intro}
            role={specialist.role}
            breadcrumbs={[
              { title: 'Spaarne Gasthuis', url: '/' },
              { title: 'Specialisten', url: '/specialisten' },
              { title: `${specialist.name} ${specialist.surName}`, url: page.url },
            ]}
          />
        )),
        //first render the quote with image block
        blocksWidget(acceptVideoCookie)(quoteblock).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),

        //render all other blocks
        blocksWidget(acceptVideoCookie)(buildingBlocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),

        //render CV
        specialist ? fromJSX(() => <SpecialistPageCVLayout {...specialist} />) : nothing(),

        blocksWidget(acceptVideoCookie)(relatedBlock).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
        //render button to overview
        fromJSX(() => (
          <SpecialistPageButtonLayout
            buttons={departments
              .map((subDepartment) => ({
                title: subDepartment,
                url: `/specialisten?filter=${encodeURIComponent(subDepartment)}`,
              }))}
          />
        )),
      ])
    }
